import React, { useState } from 'react';
import WorkplaceHealthPlans from '../../../WorkplaceHealthPlans/WorkplaceHealthPlans';
import { HealthPlanCode } from '../../../../../../Enums/HealthPlanCode.enum';
// @ts-ignore
import styles from './ManagerHealthPlans.module.scss';
import Text from '../../../../../../Components/Base/Text/Text';
import Loading from '../../../../../../Components/Loading';
import { IWorkplaceHealthPlansSetupItem } from '../WorkplaceHealthPlansSetup/WorkplaceHealthPlansSetupItem';
import {
	useLazyAllHealthPlansQuery,
	useLazyWorkplaceHealthPlansQuery,
} from '../../../../../../graphql/graphql';
import { useEffectAsync } from '../../../../../../helpers';
import WorkplaceHealthPlansSetup from '../WorkplaceHealthPlansSetup/WorkplaceHealthPlansSetup';

interface Props {
	openCaseTypes: (healthPlanCode: HealthPlanCode) => void;
}

const ManagerHealthPlans: React.FC<Props> = ({ openCaseTypes }) => {
	const [isLoading, setIsLoading] = useState(false);
	const [data, setData] = useState<IWorkplaceHealthPlansSetupItem[]>([]);
	const [getAllHealthPlans] = useLazyAllHealthPlansQuery();
	const [getWorkplaceHealthPlans, { data: workplaceHealthPlansData }] =
		useLazyWorkplaceHealthPlansQuery();

	const handleLoad = async () => {
		setIsLoading(true);
		const temp: IWorkplaceHealthPlansSetupItem[] = [];
		const dataAll = await getAllHealthPlans({ all: true });
		const dataWorkplace = await getAllHealthPlans({ all: false });
		dataAll?.data?.healthPlans?.data?.forEach(item => {
			if (item) {
				temp.push({
					id: item.id,
					name: item.name!,
					code: item.code!,
					active:
						dataWorkplace?.data?.healthPlans?.data?.some(
							i => i?.id === item.id,
						) ?? false,
					description: item.description ?? undefined,
					settings: item.settings,
				});
			}
		});
		setData(temp);
		await getWorkplaceHealthPlans();
		setIsLoading(false);
	};

	useEffectAsync(async () => {
		await handleLoad();
	}, []);

	if (isLoading) {
		return <Loading />;
	}

	return (
		<div className={styles.wrapper}>
			<Text
				tx='component.healthPlan.workplaceHealthPlans'
				className={styles.title}
			/>
			{workplaceHealthPlansData && (
				<WorkplaceHealthPlans
					openCaseTypes={openCaseTypes}
					data={workplaceHealthPlansData}
					onUpdate={handleLoad}
				/>
			)}
			<hr />
			<Text
				tx='component.healthPlan.healthPlanWorkplacePick'
				className={styles.title}
			/>
			<WorkplaceHealthPlansSetup data={data} onUpdate={handleLoad} />
		</div>
	);
};

export default ManagerHealthPlans;
